import { authenticated_api } from './base';

/** Short client timeout: onboarding must never block on the parser. */
export const ONBOARDING_PARSE_TIMEOUT_MS = 6000;

/**
 * Ask the backend LLM parser to interpret a typed onboarding answer.
 *
 * Contract: POST /user/onboarding/parse-answer {step, text}
 * (the onboarding router is mounted under /user, like /user/onboarding/complete/) ->
 * {status: "parsed"|"clarify", industries, locations,
 *  revenue: {lower_millions, upper_millions}|null, display, clarification|null}.
 * Fixtures: Alphasearch-Backend tests/contracts/fixtures/core/onboarding_parse_answer/.
 *
 * Resolves to the response body, or null on any failure (network, timeout,
 * non-2xx, endpoint not deployed) so the caller can fall back to local parsing.
 *
 * @param {"industry"|"location"|"revenue"} step
 * @param {string} text
 * @returns {Promise<object|null>}
 */
export const parseOnboardingAnswerRemote = async (step, text) => {
  try {
    const response = await authenticated_api.post(
      '/user/onboarding/parse-answer',
      { step, text },
      { timeout: ONBOARDING_PARSE_TIMEOUT_MS }
    );
    const ok = response?.status >= 200 && response?.status < 300;
    return ok && response.data && typeof response.data === 'object' ? response.data : null;
  } catch (error) {
    return null;
  }
};
